import { type MouseEvent } from 'react'
import { flushSync } from 'react-dom'

import { useBreakpoints } from '@/components/providers/BreakpointProvider'
import { type FiltersFocusType } from '@/defs/view'
import { useReduxDispatch, useReduxSelector } from '@/store/hooks'
import { viewActions } from '@/store/view'

export const useToggleFiltersPanel = (focus?: FiltersFocusType) => {
  const dispatch = useReduxDispatch()
  const { isDesktop, loading } = useBreakpoints()
  const filtersStatus = useReduxSelector((s) => s.view.filtersStatus)
  const isOpenMobile = useReduxSelector((s) => s.view.mobileStatus === 'filters')

  const isLockedDesktop = filtersStatus === 'locked'
  const isOpenDesktop = filtersStatus === 'expanded' || isLockedDesktop

  return (e: MouseEvent<HTMLElement>) => {
    if (loading) return

    const isOpen = isDesktop ? isOpenDesktop : isOpenMobile
    const button = e.currentTarget

    // For iOS, the focus must run within the same tap handler, so the commit is forced synchronously
    flushSync(() => {
      if (focus && isDesktop && isLockedDesktop) {
        dispatch(viewActions.setFiltersFocus(focus))
        return
      }
      if (isDesktop) dispatch(viewActions.toggleFilters())
      else dispatch(viewActions.toggleMobileStatus('filters'))
      if (focus && !isOpen) dispatch(viewActions.setFiltersFocus(focus))
      if (isOpen) button.focus()
    })
  }
}
